import{distinctUntilChanged as n}from"./distinctUntilChanged.js";function t(t,r){return n((function(n,i){return r?r(n[t],i[t]):n[t]===i[t]}))}export{t as distinctUntilKeyChanged};
